import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: 'SOP流程',
    type: 'BF_SOP',
}
